import Vue from 'vue'
import errorHandling from './exceptions'
import { FEEDBACK } from '@/api'

// Envia uma mensagem de feedback
const send = (params, callback) => {
  Vue.axios.post(FEEDBACK, params)
    .then(() => {
      callback()
    })
    .catch(errorHandling)
}

export default { send }
